<template>
  <b-card no-body>
    <!-- title and dropdown -->
    <b-card-header class="pb-0">
      <b-card-title>Faturamento de {{ mesAnoExtenso }}</b-card-title>
      <b-button
        variant="link"
        class="p-0"
        @click="abrirModalCalendario"
      >
        <feather-icon
          icon="CalendarIcon"
          size="1.5x"
        />
      </b-button>
    </b-card-header>

    <b-card-body>
      <b-row>
        <b-col
          sm="2"
          class="d-flex flex-column flex-wrap text-center"
        >
          <h1 class="font-large-1 font-weight-bolder mt-2 mb-0 ml-1">
            {{ faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
          </h1>
          <b-card-text
            v-if="isMesAtual"
            :class="[diferencaClass, 'mb-0', 'absolute', 'z-index-10']"
          >
            {{ diferenca.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
          </b-card-text>
        </b-col>
        <b-col
          sm="10"
          class="d-flex justify-content-center"
        >
          <vue-apex-charts
            type="radialBar"
            height="285"
            :options="supportTrackerRadialBar.chartOptions"
            :series="supportTrackerRadialBar.series"
            class="mb-2 mt-n1"
          />
        </b-col>
      </b-row>

      <!-- chart info -->
      <div class="d-flex justify-content-around mb-1">
        <div
          class="text-center"
        >
          <b-card-text class="mb-50">
            Meta
          </b-card-text>
          <div v-if="metaMensal!=0">
            <span class="font-medium-4 font-weight-bold">{{ metaMensal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div v-else>
            <span class="font-medium-4 font-weight-bold">Defina a meta</span>
          </div>

        </div>
        <div
          class="text-center"
        >
          <b-card-text class="mb-50">
            <span>
              Tendência
            </span>

            <span class="text-muted ">
              {{ metaMensal > 0 ? '(' + (tendencia / metaMensal * 100).toFixed(2) + '%)' : '' }}
            </span>
          </b-card-text>
          <span class="font-medium-4 font-weight-bold">
            {{ tendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
          </span>

        </div>
      </div>

      <!-- Modal de Meta -->
      <b-modal
        ref="metaModal"
        title="Alterar Meta Mensal"
        ok-title="Salvar"
        cancel-title="Cancelar"
        @ok="salvarMeta"
        @cancel="fecharModal"
      >
        <b-form-group
          label="Nova Meta:"
          label-for="novaMeta"
        >
          <b-form-input
            id="novaMeta"
            v-model="novaMetaMensal"
            type="number"
            placeholder="Digite a nova meta mensal"
          />
        </b-form-group>
      </b-modal>

      <!-- Modal de Calendário -->
      <b-modal
        ref="modalCalendario"
        title="Selecione o Mês e Ano"
        ok-title="Selecionar"
        cancel-title="Cancelar"
        size="sm"
        @ok="selecionarData"
      >
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Mês"
              label-for="select-mes"
            >
              <b-form-select
                id="select-mes"
                v-model="mesSelecionado"
                :options="meses"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Ano"
              label-for="select-ano"
            >
              <b-form-select
                id="select-ano"
                v-model="anoSelecionado"
                :options="anos"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BButton, BModal, BFormGroup, BFormInput, BFormSelect,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import axios from '@/../axios-auth'
import { mapActions } from 'vuex'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  data() {
    return {
      faturamento: 0,
      tendencia: 0,
      acordosDoMes: 0,
      acordosConcluidos: 0,
      acordosCancelados: 0,
      acordosEmAndamento: 0,
      metaMensal: 0, // Inicializado com zero, será preenchido pela API
      novaMetaMensal: null,
      dataSelecionada: '', // Formato: YYYY-MM
      mesSelecionado: null,
      anoSelecionado: null,
      meses: [
        { value: '01', text: 'Janeiro' },
        { value: '02', text: 'Fevereiro' },
        { value: '03', text: 'Março' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Maio' },
        { value: '06', text: 'Junho' },
        { value: '07', text: 'Julho' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Setembro' },
        { value: '10', text: 'Outubro' },
        { value: '11', text: 'Novembro' },
        { value: '12', text: 'Dezembro' },
      ],
      anos: [], // Array para armazenar os anos
      supportTrackerRadialBar: {
        series: [0],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#fff',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#5e5873',
                  fontSize: '1rem',
                },
                value: {
                  offsetY: 15,
                  color: '#5e5873',
                  fontSize: '1.714rem',
                },
              },
            },
          },
          colors: [$themeColors.voz],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'radial',
              shadeIntensity: 1,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [40, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ['Progresso da Meta'],
        },
      },
    }
  },
  computed: {
    diasRestantes() {
      const hoje = new Date()
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate()
      return ultimoDia - hoje.getDate()
    },
    porcentagemMeta() {
      return this.metaMensal > 0 ? ((this.faturamento / this.metaMensal) * 100).toFixed(2) : 0
    },
    isMesAtual() {
      if (!this.dataSelecionada) return false
      const [ano, mes] = this.dataSelecionada.split('-')
      const hoje = new Date()
      return parseInt(ano) === hoje.getFullYear() && parseInt(mes) === hoje.getMonth() + 1
    },
    mesAnoExtenso() {
      if (!this.dataSelecionada) return ''
      const [ano, mes] = this.dataSelecionada.split('-')
      const meses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ]
      return `${meses[parseInt(mes) - 1]} de ${ano}`
    },
    diferenca() {
      // diferença entre faturamento e meta
      return this.faturamento - this.metaMensal
    },
    diferencaClass() {
      const diff = this.diferenca
      if (diff > 0) return 'text-success'
      if (diff < 0) return 'text-danger'
      return 'text-muted'
    },
  },
  watch: {
    porcentagemMeta(newVal) {
      this.supportTrackerRadialBar.series = [parseFloat(newVal)]
    },
    metaMensal(newVal) {
      localStorage.setItem('metaMensal', newVal)
    },
    dataSelecionada(newVal) {
      if (newVal) {
        this.buscarMetas()
      }
    },
  },
  created() {
    const hoje = new Date()
    this.dataSelecionada = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`
    // Inicializa os selects do modal com os valores atuais
    this.mesSelecionado = String(hoje.getMonth() + 1).padStart(2, '0')
    this.anoSelecionado = hoje.getFullYear()
    // Preenche o array de anos (ex: de 2020 até o ano atual + 2)
    const anoAtual = new Date().getFullYear()
    for (let ano = 2020; ano <= anoAtual + 2; ano++) {
      this.anos.push({ value: ano.toString(), text: ano.toString() })
    }
    this.buscarDados()
    this.buscarMetas() // Buscar metas antes dos dados de faturamento
    this.buscarDadosPorData()
    // Ensure we initialize the Vuex store with the current date
    this.updateFaturamentoSelections({
      year: hoje.getFullYear(),
      month: hoje.getMonth() + 1,
    })
  },
  mounted() {
    // Force update the store
    this.$nextTick(() => {
      this.updateFaturamentoSelections({
        year: parseInt(this.anoSelecionado),
        month: parseInt(this.mesSelecionado),
      })
    })
  },
  methods: {
    ...mapActions({
      setSelectedYear: 'graficos/setSelectedYear',
      setSelectedMonth: 'graficos/setSelectedMonth',
      updateFaturamentoSelections: 'graficos/updateFaturamentoSelections',
    }),
    buscarDados() {
      axios.get('/api/v1/acordo/listar/chart_data')
        .then(res => {
          const { dados } = res.data
          this.acordosDoMes = dados.acordos_do_mes
          this.acordosConcluidos = dados.acordos_concluidos
          this.acordosCancelados = dados.acordos_cancelados
          this.acordosEmAndamento = dados.acordos_em_andamento
        })
        .catch(() => {
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
            content: 'Erro ao obter dados',
          })
        })
    },
    abrirModalMeta() {
      this.novaMetaMensal = this.metaMensal
      this.$refs.metaModal.show()
    },
    abrirModalCalendario() {
      this.$refs.modalCalendario.show()
    },
    fecharModal() {
      this.$refs.metaModal.hide()
    },
    salvarMeta() {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(parseFloat(this.novaMetaMensal)) || !isFinite(this.novaMetaMensal)) {
        // eslint-disable-next-line no-alert
        alert('Por favor, insira um número válido para a meta.')
        return
      }
      this.metaMensal = parseFloat(this.novaMetaMensal)
      this.fecharModal()
      this.buscarDadosPorData()
    },
    selecionarData() {
      this.dataSelecionada = `${this.anoSelecionado}-${this.mesSelecionado}`
      this.$refs.modalCalendario.hide()

      // This is the important part that connects Tracker to GraficoMensal via Vuex
      this.updateFaturamentoSelections({
        year: parseInt(this.anoSelecionado),
        month: parseInt(this.mesSelecionado),
      })

      this.buscarMetas() // Buscar metas antes dos dados para atualizar a meta
      this.buscarDadosPorData()
    },
    buscarMetas() {
      if (!this.dataSelecionada) return

      const [ano, mes] = this.dataSelecionada.split('-')

      axios.get(`api/v1/dashboard/metas_credores?mes=${mes}&ano=${ano}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          accept: 'application/json',
        },
      })
        .then(response => {
          // Corrigindo para acessar a estrutura correta da resposta
          const { dados } = response.data
          let totalMeta = 0

          if (dados && dados.length > 0) {
            dados.forEach(item => {
              totalMeta += parseFloat(item.meta || 0)
            })

            this.metaMensal = totalMeta
          } else {
            this.metaMensal = 0
          }
        })
        .catch(() => {
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
            content: 'Erro ao buscar dados de metas',
          })
          this.metaMensal = 0
        })
    },
    buscarDadosPorData() {
      if (!this.dataSelecionada) return

      const [ano, mes] = this.dataSelecionada.split('-')
      const hoje = new Date()
      const selectedYear = parseInt(ano)
      const selectedMonth = parseInt(mes) - 1
      const totalDays = new Date(selectedYear, selectedMonth + 1, 0).getDate()

      // Helper: conta os dias úteis (segunda a sexta) entre startDay e endDay (inclusive), excluindo feriados
      function countWorkingDays(year, month, startDay, endDay, holidays) {
        let count = 0
        for (let d = startDay; d <= endDay; d++) {
          const date = new Date(year, month, d)
          const dayOfWeek = date.getDay()
          const dateString = date.toISOString().split('T')[0] // Formato YYYY-MM-DD
          if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(dateString)) {
            count++
          }
        }
        return count
      }

      const holidays = [
        '2025-01-01', '2025-03-03', '2025-03-04', '2025-04-18', '2025-04-21', '2025-05-01', '2025-09-07', '2025-10-12', '2025-11-02', '2025-11-15', '2025-12-25',
        '2026-01-01', '2026-02-16', '2026-02-17', '2026-04-03', '2026-04-21', '2026-05-01', '2026-09-07', '2026-10-12', '2026-11-02', '2026-11-15', '2026-11-20', '2026-12-25',
      ]

      axios.post('api/v1/credores/faturamento/geral/dia', { ano: selectedYear, mes: selectedMonth + 1 }, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      })
        .then(res => {
          this.faturamento = res.data.reduce((total, item) => total + parseFloat(item.total), 0)

          // Conta os dias úteis no mês
          const totalWorkingDays = countWorkingDays(selectedYear, selectedMonth, 1, totalDays, holidays)

          if (hoje.getFullYear() === selectedYear && hoje.getMonth() === selectedMonth) {
            // Mês em andamento: contar os dias úteis já corridos
            const workingDaysSoFar = countWorkingDays(selectedYear, selectedMonth, 1, hoje.getDate(), holidays)
            const mediaDiariaUtil = workingDaysSoFar > 0 ? this.faturamento / workingDaysSoFar : 0
            this.tendencia = mediaDiariaUtil * totalWorkingDays
          } else if (hoje > new Date(selectedYear, selectedMonth, totalDays)) {
            // Mês já terminou – usar faturamento como tendência
            this.tendencia = this.faturamento
          } else {
            this.tendencia = 0
          }
        })
        .catch(() => {
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
            content: 'Erro ao buscar dados de faturamento',
          })
          this.faturamento = 0
          this.tendencia = 0
        })
    },
  },
}
</script>
